





























































































import type { Category } from '@aspenware-library/types'
import { defineComponent } from '@vue/composition-api'
import { categoryGetters, useUiState, useCategories } from '@aspenware-library/composables'
import { mapGetters } from 'vuex'

const { isNavSidebarOpen } = useUiState()
const { categories } = useCategories()

export default defineComponent({
  name: 'HeaderNavigation',
  data() {
    return {
      categoryGetters,
    }
  },
  computed: {
    orderedCategories() {
      return categoryGetters.getTopMenuCategories(categories.value)
    },
    isNavSidebarOpen: {
      get() {
        return isNavSidebarOpen.value
      },
      set(val) {
        isNavSidebarOpen.value = val
      },
    },

    isOnCatalogPage() {
      return !categoryGetters.shouldUseExternalRoute(this.$route.path)
    },

    /*
      show categories when on catalog page and ready for category navigation or always if not on a catalog page
     */
    showCategories() {
      return (this.isOnCatalogPage && this.readyForCategoryNavigation) || true
    },

    ...mapGetters({
      readyForCategoryNavigation: 'products/readyForCategoryNavigation',
    }),
  },
  methods: {
    getCategoryLink(category: Category) {
      return categoryGetters.getCategoryLink({
        category,
      })
    },
  },
})
